export default __webpack_public_path__ + "static/media/ecran_1_je_decide_NL.c1071464.png";